var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSortAsc18X18 = function SvgSortAsc18X18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sort-asc-18x18_svg__a)",
    stroke: "#1A1E2C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6.75h4.5M9.75 4.5h6.75M9.75 9H12M4.5 15V3M1.5 6.228 4.5 3l3 3.228"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sort-asc-18x18_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgSortAsc18X18;